export default {
    mixins: [],
    data: () => ({
        binCard: null,
        jwt: "",
        redirect3DS: {
            ddcUrl: document.querySelector('meta[name="ddcUrl"]').getAttribute("content"),
            ddcOrigin: document.querySelector('meta[name="ddcOrigin"]').getAttribute("content"),
            challengeUrl: document.querySelector('meta[name="challengeUrl"]').getAttribute("content")
        },
        getUrl3DS: {},
        redirect3DSObj: {},
        isRequired3DS: false,
        requiredChallenge: false,
        sessionId: null,
        challengeJWT: null,
        challengeMD: null,
        saleDetail: {

        },
        redirectDetails: {}
    }),
    computed: {},
    watch: {},
    methods: {
        getBinCard(card) {
            // Retiramos los espacios sobre la tarjeta y la preparamos
            return this.removeSpace(card).substring(0, 6);
        },
        /*
         * Función para lanzar ventana de confirmación  de compra
         * este es un paso previo a Payment, por lo cual se incrementa el step         
         */
        async ConfirmationPayment() {                     
            try {
                if (this.currentStep === 2) {                      
                    document.getElementById("modalConfirmationPay").classList.remove("hidden");                     
                    return;
                }

                this.currentStep++;
            } catch (error) {
                this.$store.dispatch("setLoading", false);
                Vue.$toast.open({
                    message: this.$t("Forms.error_sale"),
                    type: "error",
                });

                this.$router.go(this.$router.currentRoute)
            }                      
        },
        /**
         * Función para realizar el flujo de pago 
         * Este método se manda a llamar cuando el usuario realiza la acción de confirmar compra       
         */
        async Payment() {
            try {
                if (this.currentStep === 2) {
                    this.closeModalConfirmation();
                    this.$store.dispatch("setLoading", true);
                    this.binCard = this.getBinCard(this.PaymentMethods.card);
                    const parameters = {
                        currency: this.$store.state.Currency,
                        cardNumber: this.binCard,
                        bankId: this.CardInfo.IdBank
                    };
                    // this.redirect3DSObj
                    
                    const response = await this.$store.dispatch("GatewayPayment", parameters);
                    this.$store.dispatch("setLoading", false);
                    // const { token } = response;
                    this.jwt = response.token;

                    // Verificamos si el MOP retorna el TOKEN para saber si es requerida una validacion 3DS
                    if (response?.token) {
                        this.isRequired3DS = true;
                        // Instanciamos el primer Iframe
                        this.firstIframe();
                    } else {
                        this.Booking();
                    }

                    return;
                }

                this.currentStep++;
            } catch (error) {
                this.$store.dispatch("setLoading", false);
                Vue.$toast.open({
                    message: this.$t("Forms.error_sale"),
                    type: "error",
                });

                this.$router.go(this.$router.currentRoute)

            }
        },
        async closeModalConfirmation () {
            document.getElementById("modalConfirmationPay").classList.add("hidden"); 
        },
        firstIframe() {
            const innerHtml = `
              <body onload='document.collectionForm.submit();'>
                <form id='collectionForm' name='collectionForm' method='POST' action='${this.getUrl3DS.ddcUrl}'>
                    <input type='hidden' name='Bin' value='${this.binCard}'>
                    <input type='hidden' name='JWT' value='${this.jwt}'>
                </form>
              </body>
            `;

            const iframe = document.createElement('iframe');
            iframe.id = 'ddcIframe';
            iframe.width = 0;
            iframe.height = 0;
            iframe.style.visibility = 'hidden';
            iframe.style.display = 'none';
            iframe.target = '_top';
            iframe.srcdoc = innerHtml;
            document.body.appendChild(iframe);

        },
        challengeIframe() {
            // iframe challenge
            const innerHtml = `
            <body onload='document.getElementById("challengeForm").submit();'>
                <form id='challengeForm' method='POST' action='${this.getUrl3DS.challengeUrl}'>
                    <input type='hidden' name='JWT' value='${this.challengeJWT}' />
                    <input type='hidden' name='MD' value='${this.challengeMD}' />
                </form>
            </body>
            `;

            const iframe = document.createElement('iframe');
            iframe.id = 'challengeIframe';
            iframe.width = 400;
            iframe.height = 600;
            iframe.target = '_top';
            iframe.srcdoc = innerHtml;
            const challengeContainer = document.getElementById('challengeFormContainer');
            challengeContainer.appendChild(iframe);
        },
        eventPostMessageStepOne() {
            window.addEventListener("message", (event) => {
                const REDIRECT_ORIGIN = this.getUrl3DS.ddcOrigin;
                const CHALLENGE_COMPLETED_MESSAGE = 'CHALLENGE_COMPLETED';

                // 3DS Paso 1 - Se realiza el primer cobro a Booking, retorna los valores de la venta y si va a requerir un challenge
                if (event.origin === REDIRECT_ORIGIN) {
                    const data = JSON.parse(event.data);

                    if (data && data?.Status && data?.SessionId) {
                        this.sessionId = data.SessionId;
                    }

                    this.Booking()
                        .then(response => {

                            const PAYMENT_APPROVED_STATUS = 2;
                            let isPaymentApproved = response.statusPayment === PAYMENT_APPROVED_STATUS;
                            if (!isPaymentApproved && response.redirectDetails) {
                                const redirectDetails = response.redirectDetails[0];
                                // Recuperamos los valores para poder instanciar el segundo Iframe
                                this.challengeJWT = redirectDetails.challengeId;
                                this.challengeMD = redirectDetails.sessionId;
                                this.currentStep = 3;

                                this.saleDetail = response;
                                this.redirectDetails = redirectDetails;

                                this.isRequired3DS = false;
                                this.requiredChallenge = true;

                                this.challengeIframe();
                            }
                            
                        })
                        .catch(error => {
                            this.$store.dispatch("setLoading", false);
                            this.$router.go(this.$router.currentRoute)
                        });

                }

                // 3DS Paso 2 - Se realiza el segundo cobro a Booking, con el fin de completar el Challenge
                if (event.origin === window.location.origin && event?.data?.message === CHALLENGE_COMPLETED_MESSAGE) {
                    this.Booking().then(response => { }).catch(error => {
                        this.$store.dispatch("setLoading", false);
                        this.$router.go(this.$router.currentRoute);
                    });
                }
            }, false);
        }
    }, 
    mounted() {
        // Validamos el entorno y asignamos la url
        this.getUrl3DS = this.redirect3DS;
    }
};

// 4000000000001091
// 4152313475595729